import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
// Style
import {
  Grid,
  Row,
  Col,
  Panel,
  Tabs,
  Tab,
  FormControl,
  FormGroup,
  Button
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Component
import SideMenu from '../ManageListing/SideMenu/SideMenu';
import Reservation from '../Reservation/Reservation';
import NoItem from '../Reservation/NoItem/NoItem';
import Loader from '../Loader/Loader';
import CustomPagination from '../CustomPagination/CustomPagination';
import ModalFilter from './ModalFilter/ModalFilter';
import history from '../../core/history';
import { openFilterModal } from '../../actions/modalActions';
// Locale
import messages from '../../locale/messages';
import { debounce } from '../../helpers/debounce';
//Image
import addIcon from '/public/SiteIcons/reservationFilter.svg';
import bt from '../../components/commonStyle.css';
import s from './ManageReservation.css';

const ManageReservation = ({
  data: { loading, getAllReservation, refetch },
  setStateVariable,
  searchKey,
  currentPage,
  listId,
  startDate,
  endDate,
  orderBy,
  dateFilter,
  userType, type }) => {

  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  useEffect(() => {
    let variables = {
      searchKey,
      currentPage,
      dateFilter: type
    };
    setStateVariable(variables);
    refetch(variables)
  }, [searchKey, dateFilter, type])

  const handleSearchChange = useCallback(debounce((values) => {
    let variables = {
      searchKey: values,
      currentPage: 1
    };
    setStateVariable(variables);
    refetch(variables);
  }), [setStateVariable, refetch]);

  const paginationData = useCallback((currentPage) => {
    let variables = { currentPage };
    setStateVariable(variables);
    refetch(variables);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, [setStateVariable, refetch]);

  const handleChange = useCallback(({ listId, startDate, endDate, orderBy }) => {
    let variables = { currentPage: 1, listId, orderBy, startDate, endDate, searchKey };
    setStateVariable(variables);
    refetch(variables);
  }, [setStateVariable, refetch]);

  const handleSelect = useCallback((key) => {
    let variables = { currentPage: 1, searchKey };
    if (key === 1) {
      variables.dateFilter = 'pending';
      setStateVariable(variables);
      history.push('/reservation/pending');
    } else if (key === 2) {
      variables.dateFilter = 'current';
      setStateVariable(variables);
      history.push('/reservation/current');
    } else {
      variables.dateFilter = 'previous';
      setStateVariable(variables);
      history.push('/reservation/previous');
    }
    refetch(variables);
  }, [setStateVariable]);

  return (
    <>
      <Grid fluid className={'dashBoardContainer'}>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'dashBoardListingGrid'}>
              <SideMenu />
              <div className={cx('commonListingBg', 'tripContainer')}>
                <Panel className={cx(s.panelHeader)}>
                <div className={cx(s.panelBorder, 'tabReservation')}>
                    <Tabs activeKey={type == 'current' ? 2 : type == 'previous' ? 3 : 1} id="uncontrolled-tab-example" onSelect={(e) => handleSelect(e)}>
                      <Tab eventKey={1} title={<FormattedMessage {...messages.pendingTab} />} />
                      <Tab eventKey={2} title={<FormattedMessage {...messages.upcomingTab} />} />
                      <Tab eventKey={3} title={<FormattedMessage {...messages.previousTab} />} />
                    </Tabs>
                  </div>
                  <div className={s.listFlex}>
                    {getAllReservation && getAllReservation.totalCount > 0 && <>
                      <div className={s.mobileSearchWidth}>
                        <FormGroup className={s.noMargin}>
                          <FormControl
                            type="text"
                            placeholder={formatMessage(messages.searchReservations)}
                            onChange={(e) => handleSearchChange(e.target && e.target.value)}
                            className={cx(s.formControlInput, s.searchReservationInput, 'prefixIconInputRtl')}
                            value={searchKey}
                          />
                        </FormGroup>
                      </div>
                      <Button className={cx({ [s.linkCssActive]: (listId || startDate || endDate || orderBy) }, s.linkCss, s.mobileSearchWidth, 'svgImg')} onClick={() => dispatch(openFilterModal())}>
                        <img src={addIcon} className={cx(s.plusIcon, 'addPlusIcon')} />
                        <FormattedMessage {...messages.filters} />
                      </Button>
                    </>}
                  </div>
                  <ModalFilter
                    handleResults={handleChange}
                    refetch={refetch}
                    type={dateFilter}
                  />
                  {
                    loading && <Loader type={"text"} />
                  }
                  {
                    !loading && getAllReservation !== undefined && getAllReservation !== null
                    && getAllReservation.reservationData.length > 0 && <Reservation
                      data={getAllReservation.reservationData}
                      userType={userType}
                      currentPage={currentPage}
                      searchKey={searchKey}
                      listId={listId}
                      startDate={startDate}
                      endDate={endDate}
                      orderBy={orderBy}
                      dateFilter={dateFilter}
                    />
                  }
                  {
                    getAllReservation !== undefined && getAllReservation !== null
                    && getAllReservation.reservationData.length > 0 &&
                    <CustomPagination
                      total={getAllReservation.count}
                      currentPage={currentPage}
                      defaultCurrent={1}
                      defaultPageSize={5}
                      change={paginationData}
                      paginationLabel={formatMessage(messages.panelReservation)}
                    />
                  }
                  {
                    !loading && getAllReservation !== undefined && getAllReservation !== null
                    && getAllReservation.reservationData.length === 0 && <NoItem
                      userType={userType}
                      type={dateFilter}
                    />
                  }
                </Panel>
              </div>
            </div>
          </Col>
        </Row>
      </Grid>
    </>
  );
}

ManageReservation.propTypes = {
  formatMessage: PropTypes.func,
  userType: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    getAllReservation: PropTypes.shape({
      count: PropTypes.number,
      reservationData: PropTypes.array
    }),
    refetch: PropTypes.func
  })
};
export default withStyles(bt, s)(ManageReservation);
